<div>
	<waiting-room-filters></waiting-room-filters>
	<waiting-room-table></waiting-room-table>
</div>
